<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">
	  
	  <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
		  <el-form-item>
	    	  <el-select v-model="query.searchtype" placeholder="请选择关键字搜索类型" @change="query.ischange=true">
			      <el-option v-for="(item,index) in searchtypelists" :label="item.name" :value="item.id" :key="index" />
			  </el-select>
    	  </el-form-item>
		  <el-form-item>
	    	  <el-input v-model="query.keyword" @change="query.ischange=true" clearable placeholder="请输入搜索关键字" />
    	  </el-form-item>
		  <el-form-item>
	    	  <el-button type="warning" size="small" @click="getgoodslists">搜索</el-button>
			  <el-button type="warning" size="small" @click="addmatchgoods">新增</el-button>
			  <!--
			  <el-button type="warning" size="small">下载模板</el-button>
			  <el-button type="warning" size="small">导入模板</el-button>
			  -->
    	  </el-form-item>
	  </el-form>

	  <div class="backborder2" style="margin-top:10px">
	  	  <el-table ref="matchTable" :data="lists" style="width: 100%" v-loading="query.loading" tooltip-effect="dark">
			  <el-table-column type="expand">
		    		<template slot-scope="props">
			    		<el-table :data="props.row.match">
							<el-table-column prop="productid" label="productid" width="110" align="center">
								<template slot-scope="goods">
									<span class="cz-pindd-goods-detail">{{goods.row.productid}}</span>
								</template>
							</el-table-column>
				            <el-table-column prop="name" label="匹配商品名称">
								<template slot-scope="goods">
									<span class="cz-pindd-goods-detail">{{goods.row.productname}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="name" label="编号" width="200px" align="center">
								<template slot-scope="goods">
									<span class="cz-pindd-goods-detail">{{goods.row.number}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="name" label="数量" width="200px" align="center">
								<template slot-scope="goods">
									<span class="cz-pindd-goods-detail">{{goods.row.num}} {{goods.row.unit}}</span>
								</template>
							</el-table-column>
			            </el-table>
		            </template>
		      </el-table-column>
			  
			  <el-table-column label="id" width="100">
			  	  <template slot-scope="props">
					  <span class="cz-pindd-goods-detail">{{props.row.id}}</span>
				  </template>
			  </el-table-column>
			  <el-table-column label="拼多多商品名称">
			  	  <template slot-scope="props">
					  <span class="cz-pindd-goods-detail">{{props.row.name}}</span>
					  <span class="cz-pindd-goods-detail" style="font-size:12px;color:#999999">规格：{{props.row.spec}}</span>
				  </template>
			  </el-table-column>
			  <el-table-column label="skuid" align="center"  width="200px">
			  	  <template slot-scope="props">
					  <span class="cz-pindd-goods-detail">{{props.row.skuid}}</span>
				  </template>
			  </el-table-column>
			  <el-table-column label="添加时间" align="center"  width="200px">
			  	  <template slot-scope="props">
					  <span class="cz-pindd-goods-detail">{{props.row.inputtime}}</span>
				  </template>
			  </el-table-column>
			  <el-table-column label="操作" align="center"  width="300px">
			  	  <template slot-scope="props">
					  <el-button type="warning" size="small" round @click="editgoods(props.row)">编辑</el-button>
					  <el-button type="warning" size="small" round @click="getmatchgoods(props.row)">匹配宠赞商品</el-button>
					  <el-button type="" size="small" round @click="delpinddgoods(props.row)">删除</el-button>
				  </template>
			  </el-table-column>
		  </el-table>
		  <div class="block">
	          <!--分页begin-->
	          <el-pagination
		          @size-change="PageSizeChange"
		          @current-change="PageCurrentChange"
		          :current-page="query.p"
		          :page-sizes="[10, 20, 50]"
		          :page-size="query.rollpage"
		          layout="total, sizes, prev, pager, next, jumper"
		          :total="query.row">
	          </el-pagination>
	          <!--分页end-->
	      </div>
	  </div>


	  <!-- 新增/编辑拼多多商品 -->
	  <el-dialog title="新增/编辑拼多多商品" :visible.sync="addquery.dialog" top="10vh" width="25%">
		  <el-form class="demo-form-inline cz-pindd-goods-add" size="small" v-loading="addquery.loading">
			  <el-form-item label="商品名称" label-width="100px">
				  <el-input v-model="addquery.name" clearable placeholder="请输入拼多多商品名称" />
			  </el-form-item>
			  <el-form-item label="商品规格" label-width="100px">
				  <el-input v-model="addquery.spec" clearable placeholder="请输入拼多多商品规格" />
			  </el-form-item>
			  <el-form-item label="商品skuid" label-width="100px">
				  <el-input v-model="addquery.skuid" clearable placeholder="请输入拼多多商品规格id" />
			  </el-form-item>
	  	  </el-form>
		  <div slot="footer" class="dialog-footer">
	          <el-button size="small" @click="addquery.dialog = false">取 消</el-button>
	          <el-button size="small" type="primary" @click="savematchgoodsinfos">确 认</el-button>
	      </div>	    
	  </el-dialog>


	  <!-- 匹配商品 -->
	  <el-dialog title="设置匹配商品信息" :visible.sync="savematchgoods.dialog" top="10vh" width="65%">
		  <el-button type="warning" size="small" round @click="getczgoods">新增匹配商品</el-button>
		  <div class="cz-match-goods-out" v-if="savematchgoods.matchinfos.length > 0" v-loading="savematchgoods.loading">
		  	  <div class="cz-match-goods-infos" v-for="(item,index) in savematchgoods.matchinfos" style="padding:15px 20px;width:calc(100% - 40px);float:left">
				  <div class="cz-match-goods-infos-main">
				  	  <div class="cz-match-goods-out-in">
				  	  <span class="cz-pindd-goods-detail" style="float:left">{{item.productname}}（规格：{{item.spec}}）</span>
					  <span class="cz-pindd-goods-detail-id" style="float:left">ID：{{item.productid}}，编号：{{item.number}}</span>
					  </div>
				  </div>
				  <div class="cz-match-goods-infos-nums">
				  	  <el-input type="number" v-model="item.num" size="small" clearable placeholder="请输入匹配数量" />
				  </div>
				  <div class="cz-match-goods-infos-nums">
				  	  <el-input v-model="item.unit" size="small" placeholder="请选择单位" @focus="getproductunits(item,index)" />
				  </div>
				  <div class="cz-match-goods-infos-btn">
				  	  <el-button type="" size="small" round @click="delmatchgoods(index)">删除</el-button>
				  </div>
			  </div>
		  </div>
		  <div class="cz-match-goods-infos-no" v-else-if="savematchgoods.matchinfos.length==0">
		  	  <img src="@/assets/packet.png" />
			  <span>还没有匹配商品</span>
		  </div>
		  <div slot="footer" class="dialog-footer">
	          <el-button size="small" @click="savematchgoods.dialog = false">取 消</el-button>
	          <el-button size="small" type="warning" @click="updatematchgoods">确 认</el-button>
	      </div>
	  </el-dialog>


	  <!-- 获取宠赞商品信息 -->
	  <el-dialog title="选择宠赞商品" :visible.sync="czgoodsquery.dialog" top="10vh" width="55%">
		  <el-form :inline="true" class="demo-form-inline" size="small">
			  <el-form-item>
				  <el-input v-model="czgoodsquery.keyword" @change="czgoodsquery.ischange=true" clearable placeholder="请输入条形码/商品名称/商品编号" />
			  </el-form-item>
			  <el-form-item>
				  <el-button type="warning" size="small" @click="getczgoodsdata">搜索</el-button>
			  </el-form-item>
	  	  </el-form>
		  <el-table ref="matchTable" :data="czgoodslists" style="width: 100%" v-loading="czgoodsquery.loading" tooltip-effect="dark">
			  <el-table-column label="id" align="center" width="150px">
			  	  <template slot-scope="props">
					  <span class="cz-pindd-goods-detail">{{props.row.productid}}</span>
				  </template>
			  </el-table-column>
			  <el-table-column label="商品名称">
			  	  <template slot-scope="props">
					  <span class="cz-pindd-goods-detail">{{props.row.productname}}</span>
					  <span class="cz-pindd-goods-detail-id">规格：{{props.row.spec}}</span>
				  </template>
			  </el-table-column>
			  <el-table-column label="编号" align="center"  width="150px">
			  	  <template slot-scope="props">
					  <span class="cz-pindd-goods-detail">{{props.row.number}}</span>
				  </template>
			  </el-table-column>
			  <el-table-column label="操作" align="center"  width="150px">
			  	  <template slot-scope="props">
					  <el-button :type="props.row.isselect ? '' : 'warning' " size="small" round @click="selectandcannel(props.row)">{{props.row.isselect ? '取消商品' : '选择商品'}}</el-button>
				  </template>
			  </el-table-column>
		  </el-table>
		  <div class="block">
	          <!--分页begin-->
	          <el-pagination
		          @size-change="czPageSizeChange"
		          @current-change="czPageCurrentChange"
		          :current-page="czgoodsquery.p"
		          :page-sizes="[10, 20, 50]"
		          :page-size="czgoodsquery.rollpage"
		          layout="total, sizes, prev, pager, next, jumper"
		          :total="czgoodsquery.row">
	          </el-pagination>
	          <!--分页end-->
	      </div>
		  <div slot="footer" class="dialog-footer">
      		  <el-button size="small" @click="czgoodsquery.dialog=false">取 消</el-button>
			  <el-button type="warning" size="small" @click="saveselectgoods">确 定</el-button>
      	  </div>
	  </el-dialog>

	  <!-- 选择商品单位 -->
	  <el-dialog title="选择单位" :visible.sync="unitlists.view" top="10vh" width="30%">
		  <el-table :data="unitlists.lists" v-loading="unitlists.loading">
			  <el-table-column label="单位" align="center">
			  	  <template slot-scope="props">
					  <span class="cz-pindd-goods-detail">{{props.row.unit}}</span>
				  </template>
			  </el-table-column>
			  <el-table-column label="操作" align="center">
			  	  <template slot-scope="props">
					 <el-button type="warning" size="small" round @click="selectunits(props.row)">选择</el-button>
				  </template>
			  </el-table-column>
		  </el-table>
	  </el-dialog>
	  <!-- 选择商品单位 -->

    
  </div>
  </transition>
</template>

<script>

export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Pindd/index",
      transitionshow:true,
      actionauth:[],
	  query: {
		  act:'getpindd_goods_list',
		  token:this.$cookies.get('token'),
		  searchtype:1,
		  keyword:'',
		  loading:false,
		  ischange:false,
		  row:0,
		  p:1,
		  rollpage:10
	  },
	  lists:[],
	  searchtypelists:[
		  {id:1,name:'按拼多多商品名称搜索'},
		  {id:2,name:'按拼多多商品skuid搜索'},
		  {id:3,name:'按宠赞商品名称搜索'},
		  {id:4,name:'按宠赞商品编号搜索'},
	  ],
	  addquery: {
		  act:'addpinddgoods',
		  token:this.$cookies.get('token'),
		  dialog:false,
		  loading:false,
		  id:'',
		  name:'',
		  spec:'',
		  skuid:''
	  },

	  savematchgoods: {
		  act:'savematchgoods',
		  token:this.$cookies.get('token'),
		  pinddid:'',
		  dialog:false,
		  loading:false,
		  matchinfos:[],
	  },

	  czgoodsquery: {
		  act:'czgoodslists',
		  token:this.$cookies.get('token'),
		  keyword:'',
		  p:1,
		  rollpage:10,
		  loading:false,
		  ischange:false,
		  dialog:false,
		  row:0
	  },
	  czgoodslists:[],

	  unitlists: {
		  view:false,
		  loading:false,
		  productid:'',
		  lists:[],
		  tag:'',
	  }

      
    }
  },
  
  
  mounted(){
      //this.getactionauth(); //获取权限设置
	  this.getgoodslists();   //获取拼多多商品信息
  },
  
  methods:{


	  //获取商品单位信息
	  getproductunits(item,index) {
		  this.unitlists.view=true;
		  this.unitlists.loading=true;
		  this.unitlists.tag=index; //当前编辑商品序号
		  this.unitlists.productid=item.productid; //编辑商品id
		  this.unitlists.lists=[]; //商品内容集合

		  var resource = this.$resource(this.url);
		  resource.save({ act:'getproductunits',token:this.$cookies.get('token'),productid:item.productid}).then((res) => {
	          if(res.data.Result>0){
	              if(res.data.Result=='70001') this.$router.push('/login')
	              this.$message.error(res.data.Message);
				  this.unitlists.loading=false;
	          }else{
				  this.unitlists.lists=JSON.parse(Base64.decode(res.data.Data));
	              this.unitlists.loading=false;
	          }
	      }).catch((res) => {
	          this.unitlists.loading=false;
	      });
	  },

	  //选择单位信息
	  selectunits(item) {
		  let index=this.unitlists.tag;
		  this.savematchgoods.matchinfos[index].unitid=item.id;
		  this.savematchgoods.matchinfos[index].unit=item.unit;
		  this.unitlists.view=false;
	  },


	  //删除拼多多匹配商品信息
	  delpinddgoods(item) {
		  this.$confirm('你是否要删除该拼多多商品信息 ？', '提示', { type: 'warning' }).then(() => {
        	    // 向请求服务端删除
	            var resource = this.$resource(this.url);
	            resource.save({ act:'delpinddgoods',token:this.$cookies.get('token'),id:item.id}).then((res) => {
	            	if(res.data.Result>0){
	                    if(res.data.Result=='70001') this.$router.push('/login')
	                    this.$message.error(res.data.Message);
	                }else{
	                    this.getgoodslists();
	                }
	            }).catch((res) => {
	            	
	            });
	      }).catch(() => {
	            
	      });
	  },


	  //保存匹配的商品信息
	  updatematchgoods() {
		  if(this.savematchgoods.matchinfos.length==0) {this.$message.error('请选择要匹配的商品信息');return false;}
		  this.savematchgoods.loading=true;
	      var resource = this.$resource(this.url);
	      resource.save(this.savematchgoods).then((res) => {
	          if(res.data.Result>0){
	              if(res.data.Result=='70001') this.$router.push('/login')
	              this.$message.error(res.data.Message);
				  this.savematchgoods.loading=false;
	          }else{
	              this.savematchgoods.loading=false;
				  this.savematchgoods.dialog=false;
				  this.getgoodslists();
	          }
	      }).catch((res) => {
	          this.savematchgoods.loading=false;
	      });

	  },


	  //确认选中商品
	  saveselectgoods() {
		  let _this=this;
		  let num=-1;
		  let selectids=this.$cookies.get('pinddmatchgoods');
		  selectids ? selectids=JSON.parse(selectids) : selectids=[];
		  if(selectids.length==0) {this.$message.error('请选择要添加的商品');return false;} 
		  
		  selectids.forEach(function(t,i) {
			  num=-1;
			  _this.savematchgoods.matchinfos.forEach(function(tt,ii) {
				  if(t.productid==tt.productid) num=ii;
			  });
			  if(num==-1) _this.savematchgoods.matchinfos.push(t);
		  });
		  this.czgoodsquery.dialog=false;
	  },


	  //获取宠赞商品信息列表
	  getczgoods() {
		  this.czgoodsquery.keyword='';
		  this.czgoodsquery.p=1;
		  this.czgoodsquery.rollpage=10;
		  this.czgoodsquery.dialog=true;

		  //重置已选中的商品
		  let selectids=[];
		  let _this=this;
		  this.savematchgoods.matchinfos.forEach(function(t,i) {
			  selectids.push({productid:t.productid,productname:t.productname,spec:t.spec,number:t.number,num:t.num,unitid:t.unitid,unit:t.unit});
		  });
		  //保存选中商品信息
		  this.$cookies.set('pinddmatchgoods',JSON.stringify(selectids));
		  //查询商品信息
		  this.getczgoodsdata();
	  },

	  //获取宠赞商品数据
	  getczgoodsdata() {
		  if(this.czgoodsquery.ischange) {
			  this.czgoodsquery.p=1;
			  this.czgoodsquery.rollpage=10;
			  this.czgoodsquery.ischange=false;
		  }

		  this.czgoodsquery.loading=true;
	      var resource = this.$resource(this.url);
	      resource.save(this.czgoodsquery).then((res) => {
	          if(res.data.Result>0){
	              if(res.data.Result=='70001') this.$router.push('/login')
	              this.$message.error(res.data.Message);
				  this.czgoodsquery.loading=false;
	          }else{
	              this.czgoodsquery.loading=false;
				  this.czgoodslists=JSON.parse(Base64.decode(res.data.Data));
				  this.czgoodsquery.row=parseInt(res.data.count);
				  console.log(this.czgoodslists);

				  //匹配已选中的商品信息
				  this.matchselectgoods();  
	          }
	      }).catch((res) => {
	          this.czgoodsquery.loading=false;
	      });
	  },
	  czPageSizeChange(val) {
          this.czgoodsquery.rollpage = val;
          this.getczgoodsdata();
	  },
	  czPageCurrentChange(val) {
	      this.czgoodsquery.p = val;
	      this.getczgoodsdata();
	  },

	  //匹配已选中的商品信息
	  matchselectgoods() {
		  //匹配已选中商品信息
		  let selectids=this.$cookies.get('pinddmatchgoods');
		  selectids ? selectids=JSON.parse(selectids) : selectids=[];
		  this.czgoodslists.forEach(function(item,index) {
			  item.isselect=false;
			  selectids.forEach(function(t,i) {
				  if(item.productid==t.productid) item.isselect=true;
			  });
		  });
	  },

	  //选择、取消选择商品
	  selectandcannel(item) {
		  let selectids=this.$cookies.get('pinddmatchgoods');
		  let num=-1;

		  selectids ? selectids=JSON.parse(selectids) : selectids=[];
		  selectids.forEach(function(t,i) {
			  if(t.productid==item.productid) num=i;
		  });

		  if(item.isselect) { //取消选择
			  item.isselect=false;
			  if(num >=0) {
				  this.$delete(selectids,num);
				  this.$cookies.set('pinddmatchgoods',JSON.stringify(selectids));
			  }

		  }else { //选择商品
			  item.isselect=true;
			  if(num ==-1) {
				  selectids.push(item);
				  this.$cookies.set('pinddmatchgoods',JSON.stringify(selectids));
			  }
		  }

		  this.czgoodslists=JSON.parse(JSON.stringify(this.czgoodslists));
	  },
	  

	  //获取匹配商品信息
	  getmatchgoods(item) {
		  let _this=this;
		  this.savematchgoods.pinddid=item.id;
		  this.savematchgoods.matchinfos=[];
		  item.match.forEach(function(t,i) {
			  _this.savematchgoods.matchinfos.push({productid:t.productid,productname:t.productname,spec:t.spec,number:t.number,num:t.num,unitid:t.unitid,unit:t.unit});
		  });
		  this.savematchgoods.dialog=true;
	  },

	  //删除匹配商品信息
	  delmatchgoods(index) {
		  this.$delete(this.savematchgoods.matchinfos,index);
	  },


	  //获取拼多多商品信息
	  getgoodslists() {
		  if(this.query.ischange) {
			  this.query.p=1;
			  this.query.rollpage=10;
			  this.query.ischange=false;
		  }

		  this.query.loading=true;
	      var resource = this.$resource(this.url);
	      resource.save(this.query).then((res) => {
	          if(res.data.Result>0){
	              if(res.data.Result=='70001') this.$router.push('/login')
	              this.$message.error(res.data.Message);
				  this.query.loading=false;
	          }else{
	              this.query.loading=false;
				  this.lists=JSON.parse(Base64.decode(res.data.Data));
				  this.query.row=parseInt(res.data.count);
				  console.log(this.lists)
	          }
	      }).catch((res) => {
	          this.query.loading=false;
	      });
	  },
	  PageSizeChange(val) {
          this.query.rollpage = val;
          this.getgoodslists();
	  },
	  PageCurrentChange(val) {
	      this.query.p = val;
	      this.getgoodslists();
	  },

	  //新增拼多多商品信息
	  addmatchgoods() {
		  this.addquery.dialog=true;
		  this.addquery.id='';
		  this.addquery.act='addpinddgoods';
		  this.addquery.name='';
		  this.addquery.spec='';
		  this.addquery.skuid='';
	  },

	  
	  //编辑拼多多商品信息
	  editgoods(item) {
		  this.addquery.dialog=true;
		  this.addquery.id=item.id;
		  this.addquery.act='updatepinddgoods';
		  this.addquery.name=item.name;
		  this.addquery.spec=item.spec;
		  this.addquery.skuid=item.skuid;
	  },


	  //添加拼多多商品信息
	  savematchgoodsinfos() {
		  this.addquery.loading=true;
	      var resource = this.$resource(this.url);
	      resource.save(this.addquery).then((res) => {
	          if(res.data.Result>0){
	              if(res.data.Result=='70001') this.$router.push('/login')
	              this.$message.error(res.data.Message);
				  this.addquery.loading=false;
	          }else{
	              this.addquery.loading=false;
				  this.addquery.dialog=false;
				  this.getgoodslists();
	          }
	      }).catch((res) => {
	          this.addquery.loading=false;
	      });
	  },


  },


}
</script>

</script>
<style type="text/css">
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 3% 1%}
.cz-pindd-goods-add .el-form-item__label {letter-spacing:1px;font-size:13px;}
.cz-pindd-goods-detail {font-size:13px;display:inline-block;width:100%;line-height:23px;}
.cz-pindd-goods-detail-id {font-style:italic;font-size:12px;color:#999999;}
.cz-match-goods-out {display:inline-block;width:100%;margin-top:20px;font-size:0;}
.cz-match-goods-out-in {display:inline-block;width:100%}
.cz-match-goods-infos {padding:5px 0;display:inline-block;width:100%;transition:.3s all;}
.cz-match-goods-infos:nth-child(odd) {background:#F2F6FC}
.cz-match-goods-infos:nth-child(even) {background:#EBEEF5}

.cz-match-goods-infos-main {float:left;display:flex;align-items:center;width:60%;height:60px;}
.cz-match-goods-infos-nums {float:left;display:flex;justify-content:center;align-items:center;width:calc(15% - 20px);padding:0 10px;height:60px;}
.cz-match-goods-infos-btn {float:left;display:flex;justify-content:center;align-items:center;width:10%;height:60px;}
.cz-match-goods-infos-no {display:flex;justify-content:center;align-items:center;width:100%;margin-top:20px;background:#EBEEF5;height:160px;}
.cz-match-goods-infos-no img {width:50px;height:50px;}
.cz-match-goods-infos-no span {font-size:13px;margin-left:10px;}
.pdd-goods-match-select-title {font-size:13px;color:#f56c6c;}
.pdd-goods-match-select-title i {font-style:normal;font-size:15px;font-weight:700;padding:0 10px;}
</style>


// WEBPACK FOOTER //
// src/components/Pindd/Pinddmatch.vue